<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      服务商管理
      <small>
        /&nbsp;
        <router-link to="/distributorlist" class="TitleStyle">服务商列表</router-link>/&nbsp;编辑服务商
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">编辑服务商</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">基本信息</span>
                  </div>

                  <el-form
                    :model="ruleForm"
                    :inline="true"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="150px"
                    class="demo-form-inline"
                  >
                    <div class="GContent">
                      <el-form-item label="所属机构：" prop="institutions" class="labelstyle">
                        <tree-select
                          :options="options.filter(item => item.id === String(ruleForm.lesseeId))"
                          placeholder="请选择"
                          v-model="ruleForm.institutions"
                          :defaultExpandLevel="1"
                          :close-on-select="true"
                          noResultsText="无数据"
                          noOptionsText="无数据"
                          :clearable="false"
                          class="DistributorMargin InputWidth"
                        >
                          <div slot="value-label" slot-scope="{ node }">{{ String(node.id).includes('-') ? node.raw.parentName + ' - ' + node.label : node.label }}</div>
                        </tree-select>
                      </el-form-item>
                      <el-form-item label="大区：" v-if="regionalList.length > 0" prop="areaIds" class="labelstyle">
                        <el-select
                          v-model="ruleForm.areaIds"
                          :multiple="true"
                          clearable
                          filterable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in regionalList"
                            :disabled="!item.status"
                            :key="item.id"
                            :label="item.areaName"
                            :value="String(item.id)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="服务商渠道号:" prop="recom" class="labelstyle">
                        <el-input v-model="ruleForm.recom" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="服务商名称:" prop="recomName" class="labelstyle">
                        <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="所在分组:" prop="groupId" class="labelstyle">
                        <el-select
                          :disabled="this.hiddenbutton == 6533"
                          v-model="ruleForm.groupId"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in GroupList"
                            :key="item.groupId"
                            :label="item.groupName"
                            :value="item.groupId"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="服务商用户名:" prop="loginUser" class="labelstyle">
                        <el-input v-model="ruleForm.loginUser" class="DistributorMargin InputWidth" :disabled= true></el-input>
                      </el-form-item>
                      <el-form-item label="负责人姓名:" prop="userName" class="labelstyle">
                        <el-input v-model="ruleForm.userName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="负责人手机号:" prop="tel" class="labelstyle">
                        <el-input v-model="ruleForm.tel" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="所在省:" prop="province" class="labelstyle">
                        <el-select
                          v-model="ruleForm.province"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          @change="provinceChange"
                        >
                          <el-option
                            v-for="item in ProvincesList"
                            :key="item.provinceName"
                            :label="item.provinceName"
                            :value="item.provinceName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="所在市:" prop="city" class="labelstyle" v-if="CityShow">
                        <el-select
                          v-model="ruleForm.city"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          @change="CityChange"
                        >
                          <el-option
                            v-for="item in cityList"
                            :key="item.cityName"
                            :label="item.cityName"
                            :value="item.cityName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="所在区:"
                        prop="district"
                        class="labelstyle"
                        v-if="CountiesShow"
                      >
                        <el-select
                          v-model="ruleForm.district"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in countryList"
                            :key="item.countyName"
                            :label="item.countyName"
                            :value="item.countyName"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="详细地址:" prop="address" class="labelstyle">
                        <el-input v-model="ruleForm.address" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>

                      <div class="clear"></div>
                    </div>
                    <div class="GTitle">
                      <span class="TInfo">操作信息</span>
                    </div>
                    <div class="GContent" style="text-align:left;">
                      <el-form-item class="kfSetting">
                        <el-checkbox-group v-model="mallTypee" @change="selectType">
                          <div class="mallStyle">
                            <div><el-checkbox :label="1" disabled>PC商城 (必选)</el-checkbox></div>
                            <div class="settingValue">
                              <template>
                                <el-radio-group v-model="auditTypePC">
                                  <el-radio label="1">人工审核放行</el-radio>
                                  <el-radio label="2">自动审核放行</el-radio>
                                </el-radio-group>
                              </template>
                            </div>
                          </div>
                          <div>
                            <div><el-checkbox :label="2">O2O门店</el-checkbox></div>
                            <div class="settingValue">
                              <template>
                                <el-radio-group v-model="auditTypeO2O">
                                  <el-radio label="1">人工审核放行</el-radio>
                                  <el-radio label="2">自动审核放行</el-radio>
                                </el-radio-group>
                              </template>
                            </div>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div class="GTitle">
                      <span class="TInfo">支付账户信息</span>
                    </div>
                    <div class="GContent">
                      <el-form-item label="账户类型:" prop="bankType" class="labelstyle">
                        <el-select
                          v-model="ruleForm.bankType"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in bankType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="账户名称:" prop="trueName" class="labelstyle">
                        <el-input v-model="ruleForm.trueName" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="银行卡号:" prop="bankCard" class="labelstyle">
                        <el-input v-model="ruleForm.bankCard" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="开户银行:" prop="bankName" class="labelstyle">
                          <el-select
                          filterable
                          clearable
                          v-model="ruleForm.bankName"
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in bankList"
                            :key="item.id"
                            :label="item.bankName"
                            :value="item.bankCode"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="银行所属省:" prop="bankProvince" class="labelstyle">
                        <el-select
                          v-model="ruleForm.bankProvince"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                          @change="bankChange"
                        >
                          <el-option
                            v-for="item in ProvincesList"
                            :key="item.provinceName"
                            :label="item.provinceName"
                            :value="item.provinceName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="银行所属城市:" prop="bankCity" class="labelstyle">
                        <el-select
                          v-model="ruleForm.bankCity"
                          clearable
                          placeholder="请选择"
                          class="DistributorMargin InputWidth"
                        >
                          <el-option
                            v-for="item in bankCityoptions"
                            :key="item.cityName"
                            :label="item.cityName"
                            :value="item.cityName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="开户支行:" prop="bankBranchName" class="labelstyle">
                        <el-input
                          v-model="ruleForm.bankBranchName"
                          class="DistributorMargin InputWidth"
                        ></el-input>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.bankType === 'P'" label="持卡人身份证号:" prop="bankidCard"
                                    class="labelstyle">
                        <el-input v-model="ruleForm.bankidCard" class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.bankType === 'C'" label="统一社会信用代码:" prop="creditCode"
                                    class="labelstyle">
                        <el-input v-model="ruleForm.creditCode"
                                  :maxLength="18"
                                  @change="(val) => {
                        ruleForm.creditCode = val.toUpperCase()
                      }"
                                  class="DistributorMargin InputWidth"></el-input>
                      </el-form-item>
                      <el-form-item label="持卡人手机号:" prop="bankTel" class="labelstyle">
                        <el-input v-model="ruleForm.bankTel" class="DistributorMargin InputWidth"></el-input>
                        <p style="padding-left: 16px; color: #F56C6C;margin-bottom: 0;">（短信提醒）</p>
                      </el-form-item>
                      <div class="clear"></div>
                    </div>
                  </el-form>
                </div>
                <div style="height:46px;padding-top:16px;text-align:right;">
                  <button
                    class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                    @click="MakeSureEdit('ruleForm')" style="margin-right:16px"
                    :disabled = "disabled"
                  >确定</button>
                  <a class="swal-button swal-button--cancel btn btn-default" @click="GoBack" >取消</a>
                  <span class="clear"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- end panel -->

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: "EditDistributor",
  components: { TreeSelect },
  data() {
    var checkrecom = (rule, value, callback) => {
      setTimeout(() => {
        var reg = /^[0-9A-Za-z]{1,16}$/;
        if (!reg.test(value)) {
          callback(new Error("渠道号由数字和字母组成且小于16位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkrecomName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("用户名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checktel = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^1[3456789]\d{9}$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkbankCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg =  /^\d{8,}$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的银行卡号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkbankidCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg =  /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkCreditCode = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的统一社会信用代码'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      ruleForm: {
        bankBranchName: '',
        bankCard: '',
        bankCity: '',
        bankProvince: '',
        bankidCard: '',
        trueName: '',
        bankTel: '',
        bankType: '',
        institutions: undefined,
        areaIds: []
      },
      rules: {
        institutions: [
          { required: true, message: '请选择所属机构', trigger: 'change' }
        ],
        areaIds: [
          { required: true, message: '请选择大区', trigger: 'change' }
        ],
        recom: [
          { required: true, message: "请输入服务商渠道号", trigger: "blur" },
          { validator: checkrecom, trigger: "blur" }
        ],
        recomName: [
          { required: true, message: "请输入服务商名称", trigger: "blur" },
          { validator: checkrecomName, trigger: "blur" }
        ],
        loginUser: [
          { required: true, message: "请输入服务商用户名", trigger: "blur" },
          { validator: checkrecomName, trigger: "blur" }
        ],
        groupId: [
          { required: true, message: "请选择所在分组", trigger: "change" }
        ],
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checktel, trigger: "blur" }
        ],
        trueName: [
          { required: true, message: "请输入持卡人姓名", trigger: "blur" }
        ],
        bankName: [
          { required: true, message: "请选择银行名称", trigger: "change" }
        ],
        bankBranchName: [
          { required: true, message: "请输入开户行", trigger: "blur" }
        ],
        bankProvince: [
          { required: true, message: "请选择银行所属省", trigger: "change" }
        ],
        bankCity: [
          { required: true, message: "请选择银行所属城市", trigger: "change" }
        ],
        bankType: [
          { required: true, message: "请选择账户类型", trigger: "change" }
        ],
        bankCard: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
          { validator: checkbankCard, trigger: "blur" }
        ],
        bankidCard: [
          { required: true, message: "请输入持卡人身份证号", trigger: "blur" },
          { validator: checkbankidCard, trigger: "blur" }
        ],
        creditCode: [
          {required: true, message: "请输入统一社会信用代码", trigger: "blur"},
          {validator: checkCreditCode, trigger: "blur"}
        ],
        bankTel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checktel, trigger: "blur" }
        ]
      },
      bankList:[],
      bankCityoptions:[],
      pageNo:'1',
      pageSize:'10',
      disabled : false,
      GroupList: [],
      ProvincesList: [],
      bankType: [
        {
          label: '公司户',
          value: 'C'
        },
        {
          label: '个人户',
          value: 'P'
        }
      ],
      cityList: [],
      countryList: [],
      CityShow: false,
      CountiesShow: false,
      mallTypee: [],
      auditTypePC: '',
      auditTypeO2O: '',
      openSettingsFormList: '',
      hiddenbutton: '',
      options: [],
      regionalList: [],
      isStart: true
    };
  },
  watch: {
    'ruleForm.institutions': {
      handler (val) {
        this.regionalList = []
        if (!this.isStart) {
          this.$set(this.ruleForm, 'areaIds', [])
        }
        if (val) {
          this.getAreaPageList()
        }
      }
    }
  },
  mounted: function() {
    this.initdata();
    this.initgroup();
    this.initProvinces();
    this.initBank();
    this.initDatabutton()
    this.getOrgList()
  },
  methods: {
    getOrgList () {
      let that = this
      axios.get('/distribution/lessee/getOrgList').then(res => {
        if (res.data.code === 200) {
          let result = []
          res.data.data.map(item => {
            let obj = {}
            obj.label = item.lesseeName
            obj.id = String(item.id)
            obj.isDisabled = !item.status
            const children = item.deptList && item.deptList.length > 0 && this.getTree(item.deptList, item.id, item.lesseeName)
            obj.children = children
            result.push(obj)
          })
          that.options = result
        } else {
          http.handleEorrorCode(res, that)
        }
      }).catch((err) => {
        http.handleHttpError(err, that)
      })
    },
    getTree (tree = [], id, label) {
      let arr = []
      if (tree.length > 0) {
        tree.forEach(item => {
          let obj = {}
          obj.label = item.deptName
          obj.id = id + '-' + item.id
          obj.parentId = id
          obj.parentName = label
          obj.isDisabled = !item.status
          arr.push(obj)
        })
      }
      return arr
    },
    getAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.ruleForm.institutions && that.ruleForm.institutions.split('-')[0],
          deptId: that.ruleForm.institutions && that.ruleForm.institutions.split('-').length > 1 ? that.ruleForm.institutions.split('-')[1] : undefined,
          parentId: 0,
          areaType: 1
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.regionalList = response.data.data
          that.isStart = false
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    //显示 隐藏   按钮  数据
    initDatabutton() {
      let that = this;
      const options = {
        //  获取当前登录人角色
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.hiddenbutton = String(response.data.data.roleId);
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    selectType(){
      if(this.mallTypee.length !== 0){
        if(this.mallTypee.length == 1 && this.mallTypee[0] == 1){
          if(this.auditTypePC == ''){
            this.auditTypePC = '1';
          }
          this.auditTypeO2O = '';
        }
        if(this.mallTypee.length == 1 && this.mallTypee[0] == 2){
          if(this.auditTypeO2O == ''){
            this.auditTypeO2O = '1';
          }
          this.auditTypePC = '';
        }
        if(this.mallTypee.length == 2 && this.mallTypee[0] == 1 && this.mallTypee[1] == 2){
          this.auditTypeO2O = '1';
        }
        if(this.mallTypee.length == 2 && this.mallTypee[0] == 2 && this.mallTypee[1] == 1){
          this.auditTypePC = '1';
        }
      }else{
        this.auditTypePC = '';
        this.auditTypeO2O = '';
      }
    },
    initbankCityoptions(val){
     let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryCity",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          provinceName:val
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.bankCityoptions = response.data.data;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
     },
     initBank(){
     let that = this;
      const options = {
        url: "distribution/B2cBankInfoController/getBankInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.bankList = response.data.data;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    initProvinces() {
      let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryAllProvince",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ProvincesList = response.data.data;

          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    bankChange (val) {
      let that = this
      that.bankCityoptions = []
      that.$set(that.ruleForm, 'bankCity', undefined)
      if (val) {
        const options = {
          url: "distribution/B2cRegionalLinkageController/queryCity",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            provinceName: val
          })
        };
        axios(options)
          .then(function (response) {
            if (response.data.code == 200) {
              that.bankCityoptions = response.data.data
            } else {
              http.handleEorrorCode(response, that)
            }
          })
          .catch(error => {
            http.handleHttpError(error, that)
          })
      }
    },
    queryCity(val){
      let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryCity",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          provinceName: val
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.cityList = response.data.data;
          } else {
             http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    queryCountry(val){
      let that = this;
      const options = {
        url: "distribution/B2cRegionalLinkageController/queryCounty",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          cityName: val
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.countryList = response.data.data;
          } else {
               http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    provinceChange(val) {
      let that = this;
      if(val == ""){
        that.ruleForm.city = "";
        that.cityList = [];
        that.ruleForm.district = "";
        that.CityShow = false;
        that.CountiesShow = false;
      }else{
        const options = {
          url: "distribution/B2cRegionalLinkageController/queryCity",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            provinceName: val
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.cityList = response.data.data;
              that.ruleForm.city = "";
              if (that.ruleForm.district) {
                that.ruleForm.district = "";
              }
              that.CityShow = true;
              that.CountiesShow = false;
            } else {
                http.handleEorrorCode(response,that);
            }
          })
          .catch(error => {
            http.handleHttpError(error, that);
          });
      }
    },
    CityChange(val) {
      let that = this;
      if(val == ""){
        that.countryList = [];
        that.ruleForm.district = "";
        that.CountiesShow = false;
      }else{
        const options = {
          url: "distribution/B2cRegionalLinkageController/queryCounty",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            cityName: val
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.countryList = response.data.data;
              if (that.ruleForm.district) {
                that.ruleForm.district = "";
              }

              that.CountiesShow = true;
            } else {
                http.handleEorrorCode(response,that);
            }
          })
          .catch(error => {
            http.handleHttpError(error, that);
          });
      }
    },
    initgroup() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/queryGroupId",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          companyId: JSON.parse(localStorage.getItem('goodlist')).companyId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.GroupList = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    MakeSureEdit(formName) {
      // console.log(this.ruleForm.areaIds)
      let userName = '';
      let trueName = '';
      if(this.ruleForm.userName){
        userName = this.ruleForm.userName
      }else{
        userName = this.ruleForm.userName;
      }
      if(this.ruleForm.trueName){
        trueName = this.ruleForm.trueName
      }else{
        trueName = this.ruleForm.trueName;
      }
      let FormList = [];
      this.mallTypee.forEach((val, index) => {
        var a = {};
        a.mallType = val;
        FormList.push(a);
      });
      if(FormList.length !== 0){
        FormList.forEach((val,i) => {
          if(FormList[i].mallType && FormList[i].mallType == 1){
            FormList[i].auditType = Number(this.auditTypePC);
          }
          if(FormList[i].mallType && FormList[i].mallType == 2){
            FormList[i].auditType = Number(this.auditTypeO2O);
          }
        });
      }
      this.openSettingsFormList = JSON.parse(JSON.stringify(FormList));
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.disabled = true;
          const options = {
            url: "distribution/B2cRecomInfoController/updateRecomInfo",
            method: "post",
            headers: { "Content-Type": "application/json" },
            data: {
              lesseeId: Number(that.ruleForm.institutions.split('-')[0]),
              deptId: that.ruleForm.institutions.split('-').length > 1 ? Number(that.ruleForm.institutions.split('-')[1]) : undefined,
              areaIds: that.ruleForm.areaIds.length > 0 ? that.ruleForm.areaIds.join(',') : undefined,
              companyId: JSON.parse(localStorage.getItem('goodlist')).companyId,
              userId: JSON.parse(localStorage.getItem('goodlist')).userId,
              recomId: that.recomId,
              recom: that.ruleForm.recom,
              recomName: that.ruleForm.recomName,
              loginUser: that.ruleForm.loginUser,
              userName: userName,
              tel: that.ruleForm.tel,
              roleIds: [5100],
              idCard: that.ruleForm.idCard,
              recomType: 2,
              groupId: that.ruleForm.groupId,
              province: that.ruleForm.province,
              city: that.ruleForm.city,
              district: that.ruleForm.district,
              address: that.ruleForm.address,
              b2cPayAccountInfoVO:[{
                trueName: trueName,
                bankCard: that.ruleForm.bankCard,
                bankName: that.ruleForm.bankName,
                bankBranchName: that.ruleForm.bankBranchName,
                bankProvince: that.ruleForm.bankProvince,
                bankCity: that.ruleForm.bankCity,
                bankType: that.ruleForm.bankType,
                idCard: that.ruleForm.bankType === 'P' ? that.ruleForm.bankidCard : undefined,
                creditCode: that.ruleForm.bankType === 'C' ? that.ruleForm.creditCode : undefined,
                bankTel: that.ruleForm.bankTel
              }],
              openSettingsFormList: that.openSettingsFormList
            }
          };
          axios(options).then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.$router.push({ name: "DistributorList" });
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
               http.handleEorrorCode(response,that);
            }
          })
            .catch(function(error) {

              http.handleHttpError(error, that);
            });
        }
      });
    },
    initdata() {
      let that = this;
      if(localStorage.getItem('goodlist')){
        let goodlist =localStorage.getItem('goodlist');
        this.recomId =  JSON.parse(goodlist).recomId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
      }
      const initoptions = {
        url: "distribution/B2cRecomInfoController/queryRecomDetailByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: JSON.parse(localStorage.getItem('goodlist')).recomId,
          companyId: JSON.parse(localStorage.getItem('goodlist')).companyId
        })
      };
      axios(initoptions)
        .then(function(response) {
          if (response.data.code == 200) {
            response.data.data.bankidCard = JSON.parse(response.data.data.payAccountInfos).idCard;
            response.data.data.creditCode = JSON.parse(response.data.data.payAccountInfos).creditCode;
            let Object = {...JSON.parse(response.data.data.payAccountInfos) ,...response.data.data}
            that.ruleForm = Object;
            var institutions
            if (Object.lesseeId) {
              institutions = Object.deptId ? Object.lesseeId + '-' + Object.deptId : String(Object.lesseeId)
            }
            var areaIds = []
            if (Object.areaIds) {
              areaIds = Object.areaIds.split(',')
            }
            that.$set(that.ruleForm, 'institutions', institutions)
            that.$set(that.ruleForm, 'areaIds', areaIds)
            if(JSON.parse(response.data.data.payAccountInfos).bankName){
              that.ruleForm.bankName = JSON.parse(response.data.data.payAccountInfos).bankName;
            }
            if(JSON.parse(response.data.data.payAccountInfos).bankProvince){
              that.ruleForm.bankProvince = JSON.parse(response.data.data.payAccountInfos).bankProvince;
            }
            if(JSON.parse(response.data.data.payAccountInfos).bankCity){
              that.ruleForm.bankCity = JSON.parse(response.data.data.payAccountInfos).bankCity;
            }
            if(that.ruleForm.province && that.ruleForm.city){
              that.CityShow = true;
              that.CountiesShow = true;
              that.queryCity(response.data.data.province);
              that.queryCountry(response.data.data.city);
            }
            if(that.ruleForm.province && !that.ruleForm.city){
              that.CityShow = true;
              that.CountiesShow = false;
              that.queryCity(response.data.data.province);
            }
            if(!that.ruleForm.province && !that.ruleForm.city){
              that.CityShow = false;
              that.CountiesShow = false;
            }
            if(that.ruleForm.bankProvince){
              that.initbankCityoptions(that.ruleForm.bankProvince);
            }
            if (response.data.data.openSettingsFormList.length > 0) {
              response.data.data.openSettingsFormList.forEach((val, i) => {
                that.mallTypee.push(val.mallType)
                if (val.mallType === 1) {
                  that.auditTypePC = String(val.auditType)
                }
                if (val.mallType === 2) {
                  that.auditTypeO2O = String(val.auditType)
                }
              })
              console.log(that.ruleForm)
            }
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    GoBack() {
        this.$router.push({ name: "DistributorList" , params: { pageNo : this.pageNo , pagesize:this.pageSize}});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
  list-style: none;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderGroup {
  text-align: left;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  min-width: 150px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}
.InputWidth {
  width: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ReceiptTableTitle {
  list-style: none;
  float: left;
  color: #909399;
  padding: 12px 32px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;

  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  width: 20%;
}

.ReceiptTableContent {
  padding: 12px 32px;
  list-style: none;
  float: left;
  font-size: 14px;
  line-height: 24px;
  height: 54px;
  color: #606266;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;

  width: 20%;
  border: 1px solid #ebeef5;
}
@media screen and (min-width: 1200px) and (max-width: 1310px) {
  .InputWidth {
    width: 280px;
  }
}
.kfSetting {
  padding: 10px 30px;
}
.settingValue {
  margin-left: 30px;
}

>>> .vue-treeselect__control {
  border: 1px solid #DCDFE6;
}
>>> .vue-treeselect__placeholder{
  color: #606266;
}
>>> .vue-treeselect__label {
  color: #606266;
  font-weight: 500;
}
>>> .vue-treeselect__option--disabled .vue-treeselect__label{
  color: #c0c4cc;
}
.DistributorMargin {
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/EditDistributor.vue